import { Component, OnInit } from '@angular/core';
import { LoaderService } from 'src/app/services/loader.service';
import { UpsiParamService } from 'src/app/services/upsi-param.service';

@Component({
  selector: 'app-upsi-param',
  templateUrl: './upsi-param.component.html',
  styleUrls: ['./upsi-param.component.css']
})
export class UpsiParamComponent implements OnInit {

  EmailWithAttachment: boolean;
  AttachmentWithPassword: boolean;
  EmailToRecipient: boolean;
  EmailUpsiAdd: boolean;
  EmailUpsiEdit: boolean;

  EmailWithAttachment_id: any;
  AttachmentWithPassword_id: any;
  EmailToRecipient_id: any;
  EmailUpsiAdd_id: any;
  EmailUpsiEdit_id: any;
  // UPSI Subscription flags
  isUPSILiteActive: boolean = false;
  constructor(private upsiParamService: UpsiParamService, private loaderService: LoaderService) { }


  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }


  ngOnInit() {
    this.loaderService.disable();
    this.getOption();
    if(localStorage.getItem('isUPSILite') === 'true'){
      this.isUPSILiteActive = true;
    }

  }

  updateParam(paramOption, paramValue, paramId) {

    console.log('----------------', { 'paramOption': paramOption, 'paramValue': paramValue, 'paramId': paramId })

    if (paramOption == 'EmailUpsiAdd' && paramValue == false) {
      this.EmailWithAttachment = false;
      this.upsiParamService.setOption({ 'paramOption': 'EmailWithAttachment', 'paramValue': false, 'paramId': this.EmailWithAttachment_id }).subscribe(function (response) {


      })
    }

    if (paramOption == 'EmailUpsiAdd' && paramValue == false) {
      this.AttachmentWithPassword = false;
      this.upsiParamService.setOption({ 'paramOption': 'AttachmentWithPassword', 'paramValue': false, 'paramId': this.AttachmentWithPassword_id }).subscribe(function (response) {


      })
    }

    if (paramOption == 'EmailWithAttachment' && paramValue == false) {
      this.AttachmentWithPassword = false;
      this.upsiParamService.setOption({ 'paramOption': 'AttachmentWithPassword', 'paramValue': false, 'paramId': this.AttachmentWithPassword_id }).subscribe(function (response) {


      })
    }


    var Option = { 'paramOption': paramOption, 'paramValue': paramValue, 'paramId': paramId }
    this.upsiParamService.setOption(Option).subscribe(function (response) {


    })
    console.log('hjkhgkjdfhkjh', Option)
  }

  getOption() {
    var self = this;

    this.upsiParamService.getOption().subscribe(function (response) {
      if (response.status == 0) {
        var optionArray = response.data;
        optionArray.forEach(optionelement => {

          if (optionelement['paramOption'] == 'EmailWithAttachment') {
            console.log('optionelement', optionelement['paramOption'], optionelement['paramValue'])
            self.EmailWithAttachment = optionelement['paramValue']
            self.EmailWithAttachment_id = optionelement['_id']
          }
          if (optionelement['paramOption'] == 'AttachmentWithPassword') {
            console.log('optionelement', optionelement['paramOption'], optionelement['paramValue'])
            self.AttachmentWithPassword = optionelement['paramValue']
            self.AttachmentWithPassword_id = optionelement['_id']
          }
          if (optionelement['paramOption'] == 'EmailToRecipient') {
            console.log('optionelement', optionelement['paramOption'], optionelement['paramValue'])
            self.EmailToRecipient = optionelement['paramValue']
            self.EmailToRecipient_id = optionelement['_id']
          }
          if (optionelement['paramOption'] == 'EmailUpsiAdd') {
            console.log('optionelement', optionelement['paramOption'], optionelement['paramValue'])
            self.EmailUpsiAdd = optionelement['paramValue']
            self.EmailUpsiAdd_id = optionelement['_id']
          }
          if (optionelement['paramOption'] == 'EmailUpsiEdit') {
            console.log('optionelement', optionelement['paramOption'], optionelement['paramValue'])
            self.EmailUpsiEdit = optionelement['paramValue']
            self.EmailUpsiEdit_id = optionelement['_id']
          }


        });
      }
    })
  }
}
